import React, { Component, Suspense } from 'react';
import { useTranslation, withTranslation, Trans } from 'react-i18next';

export default function Demo() {
    return (
        <Trans i18nKey="description.part1">
            To get started, edit <code>src/App.js</code> and save to reload.
        </Trans>
    );
}
/*
// Component using the Trans component
function MyComponent() {
    return (
        <Trans i18nKey="description.part1">
            To get started, edit <code>src/App.js</code> and save to reload.
        </Trans>
    );
}

// page uses the hook
function Page() {
    const { t, i18n } = useTranslation();

    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="App">
            <div className="App-header">
                <Welcome />
                <button onClick={() => changeLanguage('ru')}>ru</button>
                <button onClick={() => changeLanguage('en')}>en</button>
            </div>
            <div className="App-intro">
                <MyComponent />
            </div>
            <div>{t('description.part2')}</div>
        </div>
    );
}

// loading component for suspense fallback
const Loader = () => (
    <div className="App">
        <div>loading...</div>
    </div>
);

// here app catches the suspense from page in case translations are not yet loaded
export default function Demo() {
    return (
        <Suspense fallback={<Loader />}>
            <Page />
        </Suspense>
    );
}*/



// WEBPACK FOOTER //
// ./src/components/Demo.jsx